import { H6, P, UL, LI, Btn } from '../../../../../AbstractElements';
import React, { Fragment } from 'react';
import i18n from '../../../../../i18n';

const JobDescription = () => {
    return (
        <Fragment>
            <div className="job-description">
                <H6>{i18n.t('Dashboard_ContractsReport_DescriptionTitle')}</H6>
                <P attrPara={{ className: 'text-start' }}>{i18n.t('Dashboard_ContractsReport_Description')}</P>
            </div>
            <div className="job-description">
                <H6>{i18n.t('Dashboard_ContractsReport_Qualifications')}</H6>
                <UL>
                    <LI>Expérience de livraison de produits iOS, Android ou web</LI>
                    <LI>5 ans ou plus d'expérience UI/UX</LI>
                    <LI>Portfolio démontrant une maîtrise des principes de design mobile et web adaptatif</LI>
                    <LI>Capacité à proposer des solutions élégantes à des problèmes ouverts</LI>
                    <LI>Aisance avec l'ambiguïté</LI>
                    <LI>Capacité à travailler sur plusieurs projets à la fois</LI>
                    <LI>Expérience en recherche utilisateur et entretiens avec les parties prenantes</LI>
                    <LI>Bonne maîtrise des outils de design standards</LI>
                    <LI>Atouts supplémentaires</LI>
                </UL>
            </div>
            <div className="job-description">
                <H6>{i18n.t('Dashboard_ContractsReport_AgencyExperience')}</H6>
                <UL>
                    <LI>Expérience avec des équipes de développement agile</LI>
                    <LI>Expérience avec les tests d'utilisabilité RITE</LI>
                    <LI>Expérience en design visuel et motion design</LI>
                    <LI>Maîtrise de Sketch et InVision</LI>
                    <LI>Connaissances en développement mobile ou web frontal</LI>
                </UL>
            </div>
            <div className="job-description">
                <H6>{i18n.t('Dashboard_ContractsReport_Perks')}</H6>
                <UL>
                    <LI>Rémunération concurrentielle</LI>
                    <LI>Assurances collectives concurrentielles</LI>
                    <LI>Régime d'épargne offert par l'entreprise</LI>
                    <LI>Vacances et congés maladie payés</LI>
                    <LI>Collations et boissons offertes</LI>
                </UL>
            </div>
            <div className="job-description">
                <Btn attrBtn={{ className: 'btn me-1', color: 'primary', type: 'button' }}><span><i className="fa fa-check"></i></span> {i18n.t('Dashboard_ContractsReport_SaveJob')}</Btn>
                <Btn attrBtn={{ className: 'btn', color: 'primary', type: 'button' }}><span><i className="fa fa-share-alt"></i></span> {i18n.t('Dashboard_ContractsReport_Share')}</Btn>
            </div>
        </Fragment>
    );
};

export default JobDescription;
